import type { FC } from 'react';
import classNames from 'classnames';

import { Link } from '@/components';

import type { PromoSpecialPresentation } from './utils';

type PromoCardTitleDescriptionBlockProps = {
  descriptionWrapClassName: string;
  extraDescriptionClassName: string;
  pres: PromoSpecialPresentation;
  titleClassName?: string;
};

export const PromoCardTitleDescriptionBlock: FC<PromoCardTitleDescriptionBlockProps> =
  ({
    descriptionWrapClassName,
    extraDescriptionClassName,
    pres,
    titleClassName,
  }) => (
    <div className={descriptionWrapClassName}>
      {pres.titleText ? (
        <h3
          className={titleClassName}
          style={pres.titleStyle}
          title={pres.titleText}
        >
          {pres.titleText}
        </h3>
      ) : null}
      <div
        aria-label={pres.descriptionAriaLabel}
        className={extraDescriptionClassName}
        role={pres.descriptionAriaLabel ? 'group' : undefined}
        title={pres.descriptionText || undefined}
      >
        <p aria-hidden="true" style={pres.descriptionStyle}>
          {pres.descriptionText}
        </p>
      </div>
    </div>
  );

type PromoCardCtaProps = {
  ctaClassName: string;
  ctaHref?: string | null;
  ctaOutlanderClassName: string;
  pres: PromoSpecialPresentation;
};

export const PromoCardCta: FC<PromoCardCtaProps> = ({
  ctaClassName,
  ctaHref,
  ctaOutlanderClassName,
  pres,
}) => {
  if (!pres.showCta || !pres.ctaText) return null;

  const className = classNames(ctaClassName, {
    [ctaOutlanderClassName]: pres.ctaOutlander,
  });
  const aria = `Go to ${pres.titleText || 'promotion'}`;

  if (ctaHref) {
    return (
      <Link
        aria-label={aria}
        className={className}
        href={ctaHref}
        style={pres.ctaMergeStyle}
      >
        {pres.ctaText}
      </Link>
    );
  }

  return (
    <div
      aria-label={aria}
      className={className}
      role="group"
      style={pres.ctaMergeStyle}
    >
      {pres.ctaText}
    </div>
  );
};
